import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type { TicketCommentCountQuery, TicketCommentCountQueryVariables } from '@/shared/api';
import TICKET_COMMENT_COUNT_QUERY from '../queries/ticketCommentCount';

/**
 * Counts the comments on a support ticket so the comment badge can be rendered. Queries TICKET_COMMENT_COUNT_QUERY with the filter and unwraps the ticketCommentCount field through the shared error handler.
 *
 * @param filter - Filter criteria identifying the ticket whose comments are counted.
 * @returns Promise resolving to the ticket comment count.
 */
const fetchTicketCommentCount = async (
  filter: TicketCommentCountQueryVariables['filter'],
): Promise<TicketCommentCountQuery['ticketCommentCount']> => {
  const client = createClient();
  const result = await client.query<TicketCommentCountQuery, TicketCommentCountQueryVariables>({
    query: TICKET_COMMENT_COUNT_QUERY,
    variables: {
      filter,
    },
  });
  return handleErrorApi(result, 'ticketCommentCount');
};

export default fetchTicketCommentCount;
